import { Stack, Typography } from '@mui/material';
import toast, { Toaster } from 'react-hot-toast';

import { TFetchError } from '@/api/api-error.types';
import CheckmarkIcon from '@/assets/svg/ui-elements/check-square-green.svg';
import XCloseWhite from '@/assets/svg/ui-elements/close-square.svg';
import { getApiErrorMessage } from '@/utils/api-error-message';

export const Toast = () => {
  return (
    <Toaster
      position="bottom-right"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        style: {
          background: 'transparent',
          boxShadow: 'none',
          padding: 0,
        },
      }}
    />
  );
};

/**
 * Standard mutation onError handler: toasts the API's error message, falling
 * back to the given text. Usage: `onError: toastApiError('Could not save.')`.
 */
export const toastApiError = (fallback: string) => (error: unknown) =>
  showToast(getApiErrorMessage(error as TFetchError, fallback), 'error');

export const showToast = (message: string, type: 'error' | 'success') =>
  toast.custom(() => (
    <Stack
      alignItems="center"
      gap="12px"
      sx={{
        border: `1px solid ${type === 'error' ? '#FF473E' : '#39CA88'}`,
        borderRadius: '7px',
        bgcolor: '#11161F',
        color: '#fff',
        p: '16px 28px',
        maxWidth: 560,
        width: 'fit-content',
      }}
    >
      {type === 'error' ? (
        <XCloseWhite width={20} height={20} />
      ) : (
        <CheckmarkIcon width={26} height={26} />
      )}

      <Typography maxWidth="400px" fontWeight={500}>
        {message}
      </Typography>
    </Stack>
  ));
